import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  gap: 8px;
  width: 268px;
  padding: 24px;
  border-radius: 32px;

  background: linear-gradient(
    180deg,
    rgba(8, 237, 220, 0.1) 0%,
    rgba(8, 237, 220, 0.15) 50%,
    rgba(8, 237, 220, 0.1) 100%
  );

  box-shadow: 0px 0px 18px 0px rgba(8, 237, 220, 0.1);
`
